exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../node_modules/css-loader/index.js!dropzone/dist/dropzone.css"), "");
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-8b474272&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/App.vue
// module id = 7
// module chunks = 0